import angular from 'angular';
import tableList from './tableList';

export default angular
  .module('components.tableList', [])
  .component('tableList', tableList).name;
